// Stub: maplibre-gl is only needed by the map traces, which are not registered
export default {};
